module.exports = __webpack_public_path__ + "static/media/logo-es-f.db721eb9.svg";